import React, { useMemo, useState } from 'react';
import { HoiPoiProvider } from '@Sage/hoi-poi-ui';

import { createTheme } from './styles/theme';
import Web5Context, { getContext } from './Web5Context';
import { CopilotProvider } from 'shards/Copilot';

let Web5Provider = React.memo(({ children, context, theme }) => {
    const [isHorizontalResizeActive, setHorizontalResizeActive] = useState(false);
    const contextWithResize = useMemo(
        () => ({
            ...context,
            isHorizontalResizeActive,
            setHorizontalResizeActive,
        }),
        [context, isHorizontalResizeActive],
    );
    const finalContext = useMemo(() => getContext(contextWithResize), [contextWithResize]);
    const hoipoiTheme = useMemo(() => createTheme(theme), [theme]);
    return (
        <Web5Context.Provider value={finalContext}>
            <HoiPoiProvider theme={hoipoiTheme}>
                <CopilotProvider>{children}</CopilotProvider>
            </HoiPoiProvider>
        </Web5Context.Provider>
    );
});

export default Web5Provider;
